



import BackgroundModeDto from './BackgroundModeDto'
import BeaconDto from './BeaconDto';
import BeaconSensitivityDto from './BeaconSensitivityDto';
import CountryDto from './CountryDto';
import FloorPlanDto from './FloorPlanDto';
import FontAlignmentDto from './FontAlignmentDto';
import FontSizeUnitDto from './FontSizeUnitDto';
import FontFamilyDto from './FontFamilyDto';
import FontStyleDto from './FontStyleDto';
import LanguageDto from './LanguageDto';
import MediumDto from './MediumDto';
import MenuItemDto from './MenuItemDto';
import MenuItemTranslationDto from './MenuItemTranslationDto';
import PinTypeDto from './PinTypeDto';
import ScreenOrientationDto from './ScreenOrientationDto';
import SiteDto from './SiteDto';
import SiteObjectDto from './SiteObjectDto';
import SiteObjectKeywordDto from './SiteObjectKeywordDto';
import SiteObjectOnFloorPlanDto from './SiteObjectOnFloorPlanDto';
import SiteObjectTranslationDto from './SiteObjectTranslationDto';
import SiteObjectTypeDto from './SiteObjectTypeDto';
import SiteSupportedLanguageDto from './SiteSupportedLanguageDto';
import StyleDto from './StyleDto';
import TourDto from './TourDto';
import TourMenuItemDto from './TourMenuItemDto';
import TourRelatedSiteObjectDto from './TourRelatedSiteObjectDto';
import TourStatusDto from './TourStatusDto';
import TourSubTypeDto from './TourSubTypeDto';
import TourSupportedLanguageDto from './TourSupportedLanguageDto';
import TourTranslationDto from './TourTranslationDto';
import TourTypeDto from './TourTypeDto';

const models = [
    BackgroundModeDto,
    BeaconDto,
    BeaconSensitivityDto,
    CountryDto,
    FloorPlanDto,
    FontAlignmentDto,
    FontSizeUnitDto,
    FontStyleDto,
    FontFamilyDto,
    LanguageDto,
    MediumDto,
    MenuItemDto,
    MenuItemTranslationDto,
    PinTypeDto,
    ScreenOrientationDto,
    SiteDto,
    SiteObjectDto,
    SiteObjectKeywordDto,
    SiteObjectOnFloorPlanDto,
    SiteObjectTranslationDto,
    SiteObjectTypeDto,
    SiteSupportedLanguageDto,
    StyleDto,
    TourDto,
    TourMenuItemDto,
    TourRelatedSiteObjectDto,
    TourStatusDto,
    TourSubTypeDto,
    TourSupportedLanguageDto,
    TourTranslationDto,
    TourTypeDto,
];

export default {
    models,
    BackgroundModeDto,
    BeaconDto,
    BeaconSensitivityDto,
    CountryDto,
    FloorPlanDto,
    FontAlignmentDto,
    FontSizeUnitDto,
    FontFamilyDto,
    FontStyleDto,
    LanguageDto,
    MediumDto,
    MenuItemDto,
    MenuItemTranslationDto,
    PinTypeDto,
    ScreenOrientationDto,
    SiteDto,
    SiteObjectDto,
    SiteObjectKeywordDto,
    SiteObjectOnFloorPlanDto,
    SiteObjectTranslationDto,
    SiteObjectTypeDto,
    SiteSupportedLanguageDto,
    StyleDto,
    TourDto,
    TourMenuItemDto,
    TourRelatedSiteObjectDto,
    TourStatusDto,
    TourSubTypeDto,
    TourSupportedLanguageDto,
    TourTranslationDto,
    TourTypeDto,
}
